import React from 'react'
import { SyncJobsDashboard } from '../modules/dashboard';

export const SyncJobsPage = () => {
    return (
        <SyncJobsDashboard />
    );
};
